import getConfig from "next/config";

const { publicRuntimeConfig } = getConfig();

const getTargeting = ({ locale, tags = [], slug = "" }) => {
  const parts = [];

  if (publicRuntimeConfig.environment !== "production") {
    parts.push("setTargeting('is_test_environment', ['true'])");
  }
  if (locale) {
    parts.push(`setTargeting('language', ['${locale}'])`);
  }

  if (tags?.length) {
    const quotedTags = tags.map((tag) => `'${tag}'`);
    parts.push(`setTargeting('tags', [${quotedTags.join(",")}])`);
  }

  if (slug) {
    parts.push(`setTargeting('slug', ['${slug}'])`);
  }

  if (parts.length === 0) {
    return "";
  }

  return `googletag.pubads().${parts.join(".")};`;
};

export default getTargeting;
